<template>
	<div :class="loading ? 'active' : ''" class="fixed w-full h-dvh top-0 left-0 z-50 bg-white flex justify-center items-center hiddenSmooth">
		<div class="flex flex-col w-full relative items-center text-center">
			<svg v-if="error == null" aria-hidden="true" class="inline w-10 h-10 text-gray-300 animate-spin fill-main" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"></path><path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"></path></svg>
			<svg v-if="error != null" class="inline w-20 h-20 fill-red-200 mb-3" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M256 32c14.2 0 27.3 7.5 34.5 19.8l216 368c7.3 12.4 7.3 27.7 .2 40.1S486.3 480 472 480H40c-14.3 0-27.6-7.7-34.7-20.1s-7-27.8 .2-40.1l216-368C228.7 39.5 241.8 32 256 32zm0 128c-13.3 0-24 10.7-24 24V296c0 13.3 10.7 24 24 24s24-10.7 24-24V184c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"/></svg>
			<div class="" v-if="error != null">
				{{ error }}
				<router-link to="/" @click="goHome()" class="w-full m-auto md:max-w-40 block text-center text-sm bg-main hover:opacity-80 transition-color duration-300 text-white font-bold py-3 px-4 rounded-lg mt-4">{{ typeof messages.home != 'undefined' ? messages.home : 'home' }}</router-link>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		computed: {
			loading () {
				return this.$store.getters.getLoadingStatus;
			},
			error () {
				return this.$store.getters.getError;
			},
			messages () {
				return this.$store.getters.getMessages;
			},
		},
		methods:{
			goHome(){
				this.$store.dispatch('setLoading', false);
				this.$store.dispatch('setError', null);
			}
		},
	};
</script>